<template lang="pug">
.addDevice
  //- Barra de navegación
  van-nav-bar(:title='$t("devices.linkAccount")', left-arrow, @click-left='close')

  .main
    .init.padding(v-if='init')
      img.addUnit__img(src='@/assets/img/addDevice.png')

      .addUnit__message.margin-double-bottom.margin-double-top
        .addUnit__message__title {{ $t("devices.import.title") }}
        .margin-halve-top 1. {{ $t("devices.import.message1") }}
        .margin-halve-top 2. {{ $t("devices.import.message2") }}

      button.van-button.van-button--primary.van-button--large(@click='init = false')
        | {{ $t("devices.import.continue") }}
    div(v-else)
      .van-cell-group__title {{ $t("devices.selectBrand") }}

      van-cell-group
        .relative(v-for='(account, key) in accounts', :key='key')
          van-cell.disabled(v-if='account.devices', :title='$t(`devices.${account.brand}`)', :value='$t("devices.linked")')
          van-cell(v-else-if='account.brand !== "nest"', :title='$t(`devices.${account.brand}`)', @click='linkAccount(account.brand)', is-link)
          van-cell.shadow(v-else-if='account.brand === "nest"', :title='$t(`devices.${account.brand}`)', @click='linkAccount(account.brand)')
            .btn-google
              img(src='@/assets/img/btn_google_light_normal.svg', alt='Sign up with Google')
              span {{ $t("devices.signInWith") }} Google

      .units__message {{ $t("devices.selectBrandInfo") }}
</template>

<script>
import DevicesService from '@/services/devices.service';
import { getErrorId } from '@/services/error.service';
import { TokenService } from '@/services/storage.service';
import OpenLinkMixin from '@/mixins/OpenLink.mixin';

export default {
  props: {
    accounts: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      init: true,
      isLoading: false,
      inAppBrowserRef: null,
    };
  },
  mixins: [OpenLinkMixin],
  methods: {
    async linkAccount(brand) {
      try {
        // Compruebo si hay una petición en curso,
        // si la hay, no hago nada
        if (this.isLoading) return;

        // Inicializo valores
        this.isLoading = true;
        this.accountError = null;

        // Realizo la petición
        const result = await DevicesService.linkAccount(brand);
        const clientId = result.client_id;
        const redirectUri = result.redirect_uri;
        const token = TokenService.getToken('token');
        let url = '';

        // Preparo el link
        if (brand === 'honeywell') {
          url = `https://api.honeywell.com/oauth2/authorize?response_type=code&redirect_uri=${redirectUri}&client_id=${clientId}&state=${token}`;
        } else if (brand === 'ecobee') {
          const scope = result.scope;
          // url = `https://api.ecobee.com/authorize?response_type=code&redirect_uri=${redirectUri}&client_id=${clientId}&scope=${scope}&state=${token}`;
          url = `https://api.ecobee.com/authorize?response_type=code&redirect_uri=${redirectUri}&client_id=${clientId}&scope=${scope}&state=${token}&ecobee_type=jwt`;
        } else if (brand === 'nest') {
          url = `${redirectUri}&state=${token}`;
        }

        // eslint-disable-next-line no-undef
        this.openLinkMixin(url, this.exitCallback);

        this.$toast.clear();
      } catch (error) {
        // Obtengo el error
        getErrorId(error);

        this.$toast.clear();
        this.$toast.fail({
          mask: true,
          message: this.$i18n.t('general.errors.default.message'),
        });
      } finally {
        this.isLoading = false;
      }
    },

    exitCallback() {
      this.close(true);
    },

    close(reload) {
      this.$emit('close', reload);
    },
  },

  created() {
    this.init = this.accounts.filter(account => account.devices).length > 0;
  },
};
</script>
<style lang="scss">
.info-google {
  font-size: 0.9em;
}

.btn-google {
  box-shadow: 0px 0px 1px 2px rgba(22, 34, 38, 0.05);
  border-radius: 3px;
  padding: 0 1em 0 0;
  margin: 1px 2px 3px 0;
  font-weight: 500;
  font-size: 0.75em;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;

  img {
    height: 35px;
    margin-right: 0.5em;
  }
}
@media screen and (max-width: 303px) {
  .btn-google {
    font-size: 0.2em;
  }

  .btn-google img {
    height: 10px;
    margin-right: 0;
  }
}
</style>
